import { render, staticRenderFns } from "./storeino_store.vue?vue&type=template&id=3656990c&"
import script from "./storeino_store.vue?vue&type=script&lang=js&"
export * from "./storeino_store.vue?vue&type=script&lang=js&"
import style0 from "./storeino_store.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports